import React from 'react';

export interface TextItemProps {
    children: any;
    hasBorder?: boolean;
    fullWidth?: boolean;
}

const TextItem = ({children, hasBorder, fullWidth}: TextItemProps) => {
    return (
        <div className={`text-item ${hasBorder ? 'border' : ''} ${fullWidth ? 'fullwidth' : 'width'}`}>
            {children}
        </div>
    )
}

export default TextItem;

